<template>
  <div class="author-info">
    <img :src="portfolioData.authorImage" alt="Author's Photo" class="author-photo" />
    <div class="author-name">
      <p>{{ portfolioData.authorNameChinese }}</p>
      <p>{{ portfolioData.authorNameEnglish }}</p>
    </div>
    <blockquote class="author-quote">
      <p>{{ portfolioData.quote }}</p>
    </blockquote>
  </div>
</template>

<script>
import resumeData from '@/data/resumeData.js';

export default {
  name: 'PortfolioSection',
  data() {
    return {
      portfolioData: resumeData.portfolioSection,
    };
  },
};
</script>

<style scoped>
@import '@/assets/css/style.css';
</style> 